import { platformStats } from '@/mocks/videos';

const features = [
  {
    icon: 'ri-sparkling-line',
    title: '内容精选',
    description: '专业编辑团队严格筛选，确保每部视频都是高品质内容，杜绝低质信息噪音，为你节省宝贵时间。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '正版保障',
    description: '全部内容均获得正版授权或为原创出品，支持创作者获得合理回报，共建健康内容生态。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    description: '支持手机、平板、电脑多终端无缝切换，观看记录云端同步，随时随地继续你的观影之旅。',
  },
  {
    icon: 'ri-download-cloud-line',
    title: '离线观看',
    description: '支持视频离线缓存，无网络环境下也能畅享精彩内容，让好内容不受网络限制。',
  },
];

export default function PlatformFeatures() {
  return (
    <section className="w-full bg-accent-50/50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
            为什么选择精品视频
          </h2>
          <p className="text-foreground-500 text-sm">
            我们致力于打造最优质的中文视频内容平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10 md:mb-12">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300 transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-4">
                <i className={`${feature.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {platformStats.map((stat) => (
            <div key={stat.label} className="text-center p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className={`${stat.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="text-xl md:text-2xl font-bold text-foreground-900">{stat.value}</div>
              <div className="text-foreground-500 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}